<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header"><i class="fa-solid fa-chart-line"></i> Statisztika</h1>
			</div>
			<div class="ms-auto">
				<help iconClass="fa-2x fa-beat" iconStyle="--fa-animation-duration: 1s;--fa-animation-iteration-count: 2;" helpId="priceHelp" title="Statisztika">
					<template v-slot:text>
						<b>Szűrés:</b>
						<p>Válassza ki azon vendégházakat amelyeknek az adataira kíváncsi majd időszakot és kattintson a szűrés gombra a leszűrt adatokat excelben is letöltheti</p>
						<b>Statisztika értelmezése:</b>
						<p>Amennyiben egynél több vendégházat választott talál egy eltérően színezett összesítő panelt itt a választott vendégházak adatait látja összeadva</p>
						<p>Vendégházanként lát egy panelt bal oldalán alap statisztikával, jobb oldalon pedig a foglalások, éjszakák, bevétel, és a kapacitás arányos eloszlását a turisták és a tagok közt</p>
						<p>amennyiben ezt látja: <i class="fa fa-calendar-xmark fa"></i><b>nincs megjeleníthető adat</b> az adott grafikonban a turista és tag bejegyzések száma is 0</p>
						<p>Egerét a kördiagramok cikkei fölé mozgatva láthatja a pontos számokat</p>
					</template>
				</help>
			</div>
		</div>
		<hr>
		<Loading v-if="!guesthouses"></Loading>
		<form @submit.prevent="getStatistics()" v-else>
			<div class="row mb-2">
				<div class="col">
					<v-select v-model="filter.guesthouse_id" :options="guesthouses" :reduce="(option) => option.id" label="name" style="min-width:300px;" class="bg-white" multiple>
						<template #search="{attributes, events}">
							<input
								class="vs__search"
								:required="filter.guesthouse_id.length == 0"
								v-bind="attributes"
								v-on="events"
								:placeholder="filter.guesthouse_id.length == 0 ? 'Válassz Vendégházakat!' : ''"
							/>
						</template>
					</v-select>
				</div>
				<div class="col">
					<date-picker v-model="filter.start_date" :config="configs.start" ref="start_date" class="form-control" placeholder="Kezdő dátum" required></date-picker>
				</div>
				<div class="col">
					<date-picker v-model="filter.end_date" :config="configs.end" ref="end_date" class="form-control" placeholder="Vég dátum" required></date-picker>
				</div>
				<div class="col">
					<button class="btn btn-success"><i class="fa fa-search"></i> Szűrés</button>
					<button type="button" class="btn btn-green ms-2" @click="downloadExcel" :disabled="excelDownload"><i class="fa fa-spin fa-cog" v-if="excelDownload"></i> <i class="fa-solid fa-file-excel"></i> Excel letöltése</button>
				</div>
			</div>
		</form>
		<Loading class="mt-4" title="Statisztika betöltése" v-if="!selected_guesthouses"></Loading>
		<NoRecords v-else-if="selected_guesthouses.length == 0" class="mt-4 p-5" title="Nincsenek megjeleníthető statisztikai adatok" main_icon="fa fa-chart-line" subtitle="Jelöljön ki vendégházakat!"></NoRecords>
		<div class="mt-4" v-else>
			<panel title="ÖSSZESÍTŐ" headerClass="bg-cyan text-white" v-if="Object.keys(selected_guesthouses).length > 1">
				<div class="row">
					<div class="col-md-6">
						<h5>Alap statisztika:</h5>
						<StatsTable 
							:income="Math.floor(selected_guesthouses.reduce((a,g) => {return a+g.sum_price;}, 0))" 
							:coupon_count="selected_guesthouses.reduce((a,g) => {return a+g.sum_coupon;}, 0)" 
							:coupon_discount_sum="selected_guesthouses.reduce((a,g) => {return a+g.coupon_price;}, 0)" 
							:booking_count="selected_guesthouses.reduce((a,g) => {return a+g.sum_bookings;}, 0)"
							:cancelled_booking_count="selected_guesthouses.reduce((a,g) => {return a+g.cancelled_bookings;}, 0)" 
							:deleted_booking_count="selected_guesthouses.reduce((a,g) => {return a+g.deleted_bookings;}, 0)" 
							:guest_member_nights="selected_guesthouses.reduce((a,g) => {return a+g.member.nights;}, 0)" 
							:guest_members="selected_guesthouses.reduce((a,g) => {return a+g.member.guests;}, 0)" 
							:guest_non_member_nights="selected_guesthouses.reduce((a,g) => {return a+g.not_member.nights;}, 0)" 
							:guest_non_members="selected_guesthouses.reduce((a,g) => {return a+g.not_member.guests;}, 0)" 
							:capacity="selected_guesthouses.reduce((a,g) => {return a+g.max_capacity;}, 0)"></StatsTable>						
					</div>
					<div class="col-md-6">
						<div class="row">
							<div class="col-6">
								<h5 class="text-center">Foglalások:</h5>
								<div class="text-center p-3" v-if="selected_guesthouses.reduce((a,g) => {return a+g.member.bookings;},0) == 0 && selected_guesthouses.reduce((a,g) => {return a+g.not_member.bookings;},0) == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.member.bookings;},0), 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.not_member.bookings;},0), 'color': 'LightBlue' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Bevétel (Ft):</h5>
								<div class="text-center p-3" v-if="selected_guesthouses.reduce((a,g) => {return a+g.member.price;},0) == 0 && selected_guesthouses.reduce((a,g) => {return a+g.not_member.price;},0) == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.member.price;},0), 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.not_member.price;},0), 'color': 'LightBlue' }
								]" text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Éjszakák:</h5>
								<div class="text-center p-3" v-if="selected_guesthouses.reduce((a,g) => {return a+g.member.nights;},0) == 0 && selected_guesthouses.reduce((a,g) => {return a+g.not_member.nights;},0) == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.member.nights;},0), 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.not_member.nights;},0), 'color': 'LightBlue' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Kapacitás:</h5>
								<div class="text-center p-3" v-if="selected_guesthouses.reduce((a,g) => {return a+g.member.capacity;},0) == 0 && selected_guesthouses.reduce((a,g) => {return a+g.not_member.capacity;},0) == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.member.capacity;},0), 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.not_member.capacity;},0), 'color': 'LightBlue' },

									{ 'label': 'Kihasználatlan', 'value' : selected_guesthouses.reduce((a,g) => {return a+g.max_capacity;}, 0)-selected_guesthouses.reduce((a,g) => {return a+g.member.capacity;},0)-selected_guesthouses.reduce((a,g) => {return a+g.not_member.capacity;},0), 'color': 'LightCoral' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
						</div>
					</div>
				</div>
			</panel>
			<panel v-for="(guesthouse,id) in selected_guesthouses" :key="id" :title="guesthouse.name">
				<div class="row">
					<div class="col-md-6">
						<h5>Alap statisztika:</h5>
						<StatsTable 
							:income="Math.floor(guesthouse.sum_price)" 
							:coupon_count="guesthouse.sum_coupon" 
							:coupon_discount_sum="guesthouse.coupon_price" 
							:booking_count="guesthouse.sum_bookings"
							:cancelled_booking_count="guesthouse.cancelled_bookings" 
							:deleted_booking_count="guesthouse.deleted_bookings" 
							:guest_member_nights="guesthouse.member.capacity" 
							:guest_members="guesthouse.member.guests" 
							:guest_non_member_nights="guesthouse.not_member.capacity" 
							:guest_non_members="guesthouse.not_member.guests" 
							:capacity="guesthouse.max_capacity"></StatsTable>	
						
					</div>
					<div class="col-md-6">
						<div class="row">
							<div class="col-6">
								<h5 class="text-center">Foglalások:</h5>
								<div class="text-center p-3" v-if="guesthouse.member.bookings == 0 && guesthouse.not_member.bookings == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : guesthouse.member.bookings, 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : guesthouse.not_member.bookings, 'color': 'LightBlue' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Bevétel (Ft):</h5>
								<div class="text-center p-3" v-if="guesthouse.member.price == 0 && guesthouse.not_member.price == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : guesthouse.member.price, 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : guesthouse.not_member.price, 'color': 'LightBlue' }
								]" text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Éjszakák:</h5>
								<div class="text-center p-3" v-if="guesthouse.member.nights == 0 && guesthouse.not_member.nights == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : guesthouse.member.nights, 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : guesthouse.not_member.nights, 'color': 'LightBlue' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
							<div class="col-6">
								<h5 class="text-center">Kapacitás:</h5>
								<div class="text-center p-3" v-if="guesthouse.member.capacity == 0 && guesthouse.not_member.capacity == 0">
									<i class="fa fa-calendar-xmark fa-3x"></i>
									<h6 class="mt-4">Nincs megjeleníthető adat</h6>
								</div>
								<vn-pie v-else :height="180" :model="[
									{ 'label': 'Tag', 'value' : guesthouse.member.capacity, 'color': 'LightSalmon' },
									{ 'label': 'Turista', 'value' : guesthouse.not_member.capacity, 'color': 'LightBlue' },
									{ 'label': 'Kihasználatlan', 'value' : guesthouse.max_capacity-guesthouse.member.capacity-guesthouse.not_member.capacity, 'color': 'LightCoral' }
								]"	text-field="label" value-field="value" :show-tooltip-percent="true"	:show-legend="true"></vn-pie>
							</div>
						</div>
					</div>
				</div>
			</panel>
		</div>
	</div>
</template>

<script>	
	import Guesthouse from '../../apis/Guesthouse';
	import Statistics from '../../apis/Statistics';
	import AppOptions from '../../config/AppOptions.vue'
	import StatsTable from '../../components/StatsTable.vue'
	import moment from 'moment'
	export default {
		data() {
			return {
				pieChart: [
					{ 'label': 'One', 'value' : 29, 'color': 'red' }, 
					{ 'label': 'Two', 'value' : 12, 'color': AppOptions.color.orange }, 
					{ 'label': 'Three', 'value' : 32, 'color': AppOptions.color.teal }, 
					{ 'label': 'Four', 'value' : 196, 'color': AppOptions.color.cyan }, 
					{ 'label': 'Five', 'value' : 17, 'color': AppOptions.color.blue }, 
					{ 'label': 'Six', 'value' : 98, 'color': AppOptions.color.purple }, 
					{ 'label': 'Seven', 'value' : 13, 'color': AppOptions.color.gray500 }, 
					{ 'label': 'Eight', 'value' : 5, 'color': AppOptions.color.componentColor }
				],
				guesthouses:null,
				selected_guesthouses:null,
				filter:{
					start_date:null,
					end_date:null,
					guesthouse_id:[],
				},
				configs: {
					start: {
						format: 'YYYY-MM-DD',
						useCurrent: false,
						showClear: true,
						showClose: true,
						//minDate: new Date(),
						maxDate: false
					},
					end: {
						format: 'YYYY-MM-DD',
						useCurrent: false,
						showClear: true,
						showClose: true,
						//minDate: new Date()
					}
				},
				excelDownload: false,
			}
		},
		components: {
			StatsTable
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		created() {
			Guesthouse.index()
			.then(response => {
				this.guesthouses = response.data;
				this.filter.guesthouse_id = this.guesthouses.map(g => g.id)
				this.filter.start_date = moment().startOf('month').format('YYYY-MM-DD');
				this.filter.end_date = moment().endOf('month').format('YYYY-MM-DD');
				this.getStatistics();
			});
		},
		methods: {
			getStatistics(){
				this.selected_guesthouses = null;
				Statistics.income(this.filter)
				.then(response => {
					this.selected_guesthouses = response.data;
				}).catch(() => {
					this.selected_guesthouses = [];
				});
			},
			downloadExcel(){
				this.excelDownload = true;
				Statistics.excel(this.filter)
				.then(response => {
					var blob=new Blob([response.data]);
					var link=document.createElement('a');
					link.href=window.URL.createObjectURL(blob);
					link.download="dimenzio_statisztika.csv";
					link.click();
				}).finally(() => {
					this.excelDownload = false;
				})
			}
		}
	};
</script>